import { connect } from 'react-redux'
import React, { Component } from 'react'
import * as strings from '../../helpers/strings';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { 
  Grid, Button 
} from '@material-ui/core';
import '../../index.css';

import * as portfolioFaultReducer from '../reducer';
import * as portfolioFaultActionMgr from '../action-mgr';

import Page from '../../common-components/Page';
import PortfolioFaultTotalize from './PortfolioFaultTotalize';
import PortfolioFaultForm from './PortfolioFaultForm';
import PortfolioFaultLog from './PortfolioFaultLog';
import PortfolioFaultGraphs from './PortfolioFaultGraphs';

const styles = {
  tabButton: {
    fontSize: '1rem',
    fontWeight: 500,
    textTransform: 'capitalize',
    padding: '15px 78px',
    cursor: 'pointer',
    borderRadius: '4px',
    backgroundColor: '#fff',
    marginRight: '15px',
    marginBottom: '10px',

    border: '1px solid #ccc',
    backgroundColor: '#f0f0f0',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    }
  },
  activeTab: {
    color: '#fff',
    backgroundColor: '#343A40',
    border: '1px solid #343A40',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
    '&:hover': {
      color: '#343A40',
      backgroundColor: '#fff',
    }
  },
  inactiveTab: {
    backgroundColor: '#ffffff',
  },
};

// Tab Constants
const TABS = {
  STATISTICS: 'faultStatistics',
  RECORDS: 'faultRecords',
};

// UI-Friendly Labels for Buttons
const TAB_LABELS = {
  [TABS.STATISTICS]: 'Fault Statistics',
  [TABS.RECORDS]: 'Fault Records',
};

class PortfolioFaultOverview extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeTab: TABS.STATISTICS, // Default to "Fault Analysis"
    };
  }
  
  handleTabChange = (tab) => this.setState({ activeTab: tab });

  renderTabs = () => {
    const { classes } = this.props;
    const { activeTab } = this.state;

    return Object.entries(TABS).map(([key, value]) => (
      <Button
        key={key}
        className={`${classes.tabButton} ${activeTab === value ? classes.activeTab : ''}`}
        onClick={() => this.handleTabChange(value)}
      >
        {TAB_LABELS[value]}
      </Button>
    ));
  };

  renderTabContent = () => {
    const { activeTab } = this.state;
    return (
      <>
        <Grid item md={2} sm={12} xs={12}>
          <PortfolioFaultForm />
        </Grid>
        <Grid item md={10} sm={12} xs={12}>
          <div>
            {activeTab === TABS.STATISTICS ? <PortfolioFaultGraphs /> : <PortfolioFaultLog />}
          </div>
        </Grid>
      </>
    );
  };
  
  render() {
    const { portfolioFaultTotalize } = this.props;

    return (
      <Page title={strings.lblFaultOverview} >
        <Grid container spacing={8} >
          <Grid item md={12} sm={12} xs={12}>
            <PortfolioFaultTotalize portfolioFaultTotalize={portfolioFaultTotalize} />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            {this.renderTabs()}
          </Grid>
            {this.renderTabContent()}
        </Grid>
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    portfolioFaultTotalize: portfolioFaultReducer.getPortfolioFaultTotalize(state)
  };
};

const mapActionsToProps = {
};

export default connect(mapStateToProps, mapActionsToProps)(
  withRouter(withStyles(styles)(PortfolioFaultOverview))
);